import { gql } from "@apollo/client";

export const GET_MY_WATCHLISTS = gql`
  query GetMyWatchlists {
    myWatchlists {
      id
      name
      order
      items {
        id
        symbol
        order
        addedAt
        notes
      }
    }
  }
`;

export const GET_WATCHLIST_WITH_PRICES = gql`
  query GetWatchlistWithPrices($watchlistId: String!) {
    watchlistWithPrices(watchlistId: $watchlistId) {
      id
      name
      items {
        id
        symbol
        order
        notes
        currentPrice
        priceChange
        priceChangePercent
      }
    }
  }
`;

export const GET_MARKET_OVERVIEW = gql`
  query GetMarketOverview {
    marketOverview {
      indices {
        symbol
        name
        price
        change
        changePercent
      }
      lastUpdated
    }
  }
`;

export const CREATE_WATCHLIST = gql`
  mutation CreateWatchlist($data: CreateWatchlistInput!) {
    createWatchlist(data: $data) {
      id
      name
    }
  }
`;

export const ADD_WATCHLIST_ITEM = gql`
  mutation AddWatchlistItem($data: AddWatchlistItemInput!) {
    addWatchlistItem(data: $data) {
      id
      symbol
      order
    }
  }
`;

export const REMOVE_WATCHLIST_ITEM = gql`
  mutation RemoveWatchlistItem($itemId: String!) {
    removeWatchlistItem(itemId: $itemId)
  }
`;
